// From NPM packages
import {
    DropdownMenu,
    DropdownToggle,
    NavItem,
    UncontrolledDropdown,
    UncontrolledTooltip,
} from "reactstrap";
import { NavLink } from "react-router-dom";

// From our project
import procoreWhiteLogo from "Images/Procore_White_Logo.png";
import procoreBlackLogo from "Images/Procore_Black_Logo.png";
import microsoftLogo from "Images/MS_Logo.svg";
import useUserContext from "Hooks/useUserContext";
import useTheme from "Hooks/useTheme";
import styles from "components/NavMenu/Components/SystemLinksDropdown/SystemLinksDropdown.module.css";

/** This is displayed in the NavMenu on the right side, just left of the username dropdown */
export default function SystemLinksDropdown() {
    const [userContext] = useUserContext();
    const { theme } = useTheme();
    const procoreLogo = theme === "dark" ? procoreWhiteLogo : procoreBlackLogo;

    const procoreLink =
        userContext.environment === "uat"
            ? "https://login-sandbox-monthly.procore.com"
            : "https://app.procore.com";

    const microsoftLink =
        userContext.environment === "uat"
            ? `https://uat-dimension.calance.us/oauth/azuread/authorize?company_id=${userContext.companyId}`
            : `https://dimension.calance.us/oauth/azuread/authorize?company_id=${userContext.companyId}`

    const allSystems = [
        { name: "Procore", url: procoreLink, logo: procoreLogo },
        { name: "Microsoft", url: microsoftLink, logo: microsoftLogo },
    ];

    const systems = allSystems.filter((s) =>
        userContext.companySystems?.toLowerCase().includes(s.name.toLowerCase())
    );

    if (systems.length === 0) return null;

    return (
        <>
            {/* Display the first logo, or the word links if there are no systems with logos */}
            {systems[0].logo ? (
                <>
                    <NavItem
                        id={`${systems[0].name}Link`}
                        tag="a"
                        href={systems[0].url}
                        target="_blank"
                    >
                        <img
                            className={styles.logo}
                            src={systems[0].logo}
                            alt={`${systems[0].name} link`}
                        />
                    </NavItem>
                    <UncontrolledTooltip target={`${systems[0].name}Link`}>
                        Go to {systems[0].name}
                    </UncontrolledTooltip>
                </>
            ) : (
                "Links"
            )}

            {/* Map the rest of the systems in a dropdown menu */}
            {systems.length > 1 && (
                <UncontrolledDropdown
                    nav
                    inNavbar
                    className={styles.userDropdown}
                >
                    <DropdownToggle
                        className={`${styles.link} me-4`}
                        nav
                        caret
                    />
                    <DropdownMenu className={styles.dropdownMenu}>
                        {systems.slice(1).map((system) => {
                            // With a logo
                            if (system.logo) {
                                return (
                                    <>
                                        <NavItem
                                            id={system.name}
                                            key={system.name}
                                            className={styles.dropdownLogo}
                                            tag={NavLink}
                                            to={system.url}
                                        >
                                            <img
                                                className={styles.logo}
                                                src={system.logo}
                                                alt={`${system} link`}
                                            />
                                        </NavItem>
                                        <UncontrolledTooltip
                                            target={system.name}
                                        >
                                            Go to {system.name}
                                        </UncontrolledTooltip>
                                    </>
                                );
                            } // No logo
                            else if (system?.name) {
                                return (
                                    <>
                                        <NavItem
                                            id={system.name}
                                            key={system.name}
                                            tag={NavLink}
                                            to={system.url}
                                        >
                                            {system.name}
                                        </NavItem>
                                        <UncontrolledTooltip
                                            target={system.name}
                                        >
                                            Go to {system.name}
                                        </UncontrolledTooltip>
                                    </>
                                );
                            }
                            return null;
                        })}
                    </DropdownMenu>
                </UncontrolledDropdown>
            )}
        </>
    );
}
